module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"ds-manager:general:title":"Менеджер источников данных","ds-manager:general:subtitle":"Список доступных источников данных"},"en":{"ds-manager:general:title":"Data source manager","ds-manager:general:subtitle":"Available data source list"}}')
  delete Component.options._Ctor
}
